import { Deserializable } from '../deserializable';
export class TransactionStatus implements Deserializable {
  id: number;
  name: string;
  helpText: string;

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }

  static canChangeStatusList = [90, 210, 227, 229, 232, 233, 235];
  static canEditTradeList = [90, 150, 210, 227, 229, 230, 232, 233, 235, 240, 241, 300];
  static canShowSaveButton = [20, 60, 210, 229, 233, 240, 241, 999];
  static confirmCFSStatusBtnVisibleList = [230, 232, 235];
  static canReprocessTrade = [227, 229, 235];
  static canReprebookTrade = [90];
  static canRetryLinkPrebookedDooyaTrade = [90];
  static canDeleteTrade = [90, 229, 233];
  static canShowRefreshDooyaButton = [150, 240, 241, 300];
  static canEditDealRateStatusList = [240, 241];
  static canEditDealType = [150, 227, 229];

  static criticalStatuses = [233];
  static emergencyStatuses = [90, 210, 227, 229, 235];
  static semiUrgentStatuses = [20, 50, 60, 221, 224, 232, 234, 251];
  static normalStatuses = [200, 222, 225, 226, 228, 230, 231, 238, 239];
  static noneStatus = [10, 100, 150, 240, 241, 250, 300, 999];

  private static pollUntilAuthorised = false;

  static setPollUntilAuthorised(enabled: boolean) {
    this.pollUntilAuthorised = enabled;
  }

  static isNoneStatus(statusId: number): boolean {
    if (statusId === 240) {
      return !this.pollUntilAuthorised;
    }
    return this.noneStatus.includes(statusId);
  }

  static isNormalStatus(statusId: number): boolean {
    if (statusId === 240) {
      return this.pollUntilAuthorised;
    }
    return this.normalStatuses.includes(statusId);
  }

  static isAuthorisedDone(statusId: number): boolean {
    if (statusId === 241) {
      return true;
    }
    if (statusId === 240) {
      return !this.pollUntilAuthorised;
    }
    return false;
  }

  static canChangeStatus(statusId: number): boolean {
    if (statusId === 240) {
      return this.pollUntilAuthorised;
    }
    return this.canChangeStatusList.includes(statusId);
  }
}
